var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "es (4) 1",
    clipPath: "url(#clip0_4765_18661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4765_18661",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 27
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 26.6191C20.1797 26.6191 26 20.7988 26 13.6191C26 6.43944 20.1797 0.619141 13 0.619141C5.8203 0.619141 0 6.43944 0 13.6191C0 20.7988 5.8203 26.6191 13 26.6191Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4765_18661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 7.11914L13 5.49414L26 7.11914V20.1191L13 21.7441L0 20.1191V7.11914Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0 0.619141H26V7.11914H0V0.619141ZM0 20.1191H26V26.6191H0V20.1191Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.3125 16.0566H6.5V11.9941H7.3125V16.0566ZM13.8125 16.0566H14.625V11.9941H13.8125V16.0566Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.5625 17.2754C11.9087 17.2754 13 16.5479 13 15.6504C13 14.7529 11.9087 14.0254 10.5625 14.0254C9.21631 14.0254 8.125 14.7529 8.125 15.6504C8.125 16.5479 9.21631 17.2754 10.5625 17.2754Z",
    fill: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M7.3125 10.7754C7.3125 10.551 7.13062 10.3691 6.90625 10.3691C6.68188 10.3691 6.5 10.551 6.5 10.7754V11.1816C6.5 11.406 6.68188 11.5879 6.90625 11.5879C7.13062 11.5879 7.3125 11.406 7.3125 11.1816V10.7754Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.625 10.7754C14.625 10.551 14.4431 10.3691 14.2188 10.3691C13.9944 10.3691 13.8125 10.551 13.8125 10.7754V11.1816C13.8125 11.406 13.9944 11.5879 14.2188 11.5879C14.4431 11.5879 14.625 11.406 14.625 11.1816V10.7754Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M10.5625 14.4316V15.6504C10.5625 15.9736 10.6909 16.2836 10.9195 16.5122C11.148 16.7407 11.458 16.8691 11.7812 16.8691C12.1045 16.8691 12.4145 16.7407 12.643 16.5122C12.8716 16.2836 13 15.9736 13 15.6504V14.4316H11.7812H10.5625Z",
    fill: "#D80027"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M7.3125 11.1816H6.5C6.27563 11.1816 6.09375 11.3635 6.09375 11.5879C6.09375 11.8123 6.27563 11.9941 6.5 11.9941H7.3125C7.53687 11.9941 7.71875 11.8123 7.71875 11.5879C7.71875 11.3635 7.53687 11.1816 7.3125 11.1816Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M14.625 11.1816H13.8125C13.5881 11.1816 13.4062 11.3635 13.4062 11.5879C13.4062 11.8123 13.5881 11.9941 13.8125 11.9941H14.625C14.8494 11.9941 15.0312 11.8123 15.0312 11.5879C15.0312 11.3635 14.8494 11.1816 14.625 11.1816Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M7.3125 16.0566H6.5C6.27563 16.0566 6.09375 16.2385 6.09375 16.4629C6.09375 16.6873 6.27563 16.8691 6.5 16.8691H7.3125C7.53687 16.8691 7.71875 16.6873 7.71875 16.4629C7.71875 16.2385 7.53687 16.0566 7.3125 16.0566Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M14.625 16.0566H13.8125C13.5881 16.0566 13.4062 16.2385 13.4062 16.4629C13.4062 16.6873 13.5881 16.8691 13.8125 16.8691H14.625C14.8494 16.8691 15.0312 16.6873 15.0312 16.4629C15.0312 16.2385 14.8494 16.0566 14.625 16.0566Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M8.125 14.4316V15.6504C8.125 16.0566 8.32812 16.3613 8.58203 16.6152L8.83594 16.3105L9.08984 16.8184C9.25665 16.8592 9.43085 16.8592 9.59766 16.8184L9.85156 16.3105L10.1055 16.6152C10.4102 16.3613 10.5625 16.0566 10.5625 15.6504V14.4316H10.1055L9.85156 14.8379L9.59766 14.4316H9.08984L8.83594 14.8379L8.58203 14.4316H8.125Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M6.19531 13.416H14.9297H6.19531ZM6.19531 14.6348H7.61719H6.19531ZM13.5078 14.6348H14.9297H13.5078Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M6.19531 13.2129C6.14144 13.2129 6.08977 13.2343 6.05168 13.2724C6.01359 13.3105 5.99219 13.3621 5.99219 13.416C5.99219 13.4699 6.01359 13.5216 6.05168 13.5596C6.08977 13.5977 6.14144 13.6191 6.19531 13.6191H14.9297C14.9836 13.6191 15.0352 13.5977 15.0733 13.5596C15.1114 13.5216 15.1328 13.4699 15.1328 13.416C15.1328 13.3621 15.1114 13.3105 15.0733 13.2724C15.0352 13.2343 14.9836 13.2129 14.9297 13.2129H6.19531ZM6.19531 14.4316C6.14144 14.4316 6.08977 14.453 6.05168 14.4911C6.01359 14.5292 5.99219 14.5809 5.99219 14.6348C5.99219 14.6886 6.01359 14.7403 6.05168 14.7784C6.08977 14.8165 6.14144 14.8379 6.19531 14.8379H7.61719C7.67106 14.8379 7.72273 14.8165 7.76082 14.7784C7.79891 14.7403 7.82031 14.6886 7.82031 14.6348C7.82031 14.5809 7.79891 14.5292 7.76082 14.4911C7.72273 14.453 7.67106 14.4316 7.61719 14.4316H6.19531ZM13.5078 14.4316C13.4539 14.4316 13.4023 14.453 13.3642 14.4911C13.3261 14.5292 13.3047 14.5809 13.3047 14.6348C13.3047 14.6886 13.3261 14.7403 13.3642 14.7784C13.4023 14.8165 13.4539 14.8379 13.5078 14.8379H14.9297C14.9836 14.8379 15.0352 14.8165 15.0733 14.7784C15.1114 14.7403 15.1328 14.6886 15.1328 14.6348C15.1328 14.5809 15.1114 14.5292 15.0733 14.4911C15.0352 14.453 14.9836 14.4316 14.9297 14.4316H13.5078Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M9.95312 9.15039C9.59766 9.15039 9.29297 9.4043 9.19141 9.70898L8.9375 9.6582C8.48047 9.6582 8.125 10.0137 8.125 10.4707C8.125 10.9277 8.48047 11.2832 8.9375 11.2832C9.29297 11.2832 9.59766 11.0801 9.69922 10.7246C9.84732 10.778 10.0078 10.7873 10.161 10.7512C10.3143 10.7152 10.4538 10.6353 10.5625 10.5215C10.6712 10.6353 10.8107 10.7152 10.964 10.7512C11.1172 10.7873 11.2777 10.778 11.4258 10.7246C11.4751 10.8784 11.5691 11.0141 11.6958 11.1142C11.8225 11.2143 11.9762 11.2744 12.1372 11.2868C12.2982 11.2992 12.4593 11.2633 12.5998 11.1838C12.7404 11.1042 12.854 10.9845 12.9263 10.8401C12.9985 10.6956 13.026 10.5329 13.0054 10.3727C12.9847 10.2126 12.9168 10.0622 12.8102 9.94079C12.7037 9.8194 12.5634 9.73251 12.4073 9.69122C12.2511 9.64994 12.0862 9.65612 11.9336 9.70898C11.8846 9.57733 11.8023 9.46062 11.6948 9.37025C11.5873 9.27988 11.4581 9.21893 11.32 9.19335C11.1819 9.16777 11.0395 9.17844 10.9067 9.22431C10.774 9.27018 10.6554 9.34969 10.5625 9.45508C10.4102 9.25195 10.207 9.15039 9.95312 9.15039ZM9.95312 9.55664C10.207 9.55664 10.3594 9.75977 10.3594 9.96289C10.3594 10.2168 10.207 10.3691 9.95312 10.3691C9.75 10.3691 9.54687 10.2168 9.54687 9.96289C9.54687 9.75977 9.75 9.55664 9.95312 9.55664ZM11.1719 9.55664C11.4258 9.55664 11.5781 9.75977 11.5781 9.96289C11.5781 10.2168 11.4258 10.3691 11.1719 10.3691C10.9687 10.3691 10.7656 10.2168 10.7656 9.96289C10.7656 9.75977 10.9687 9.55664 11.1719 9.55664ZM8.9375 10.0645L9.14062 10.1152L9.34375 10.5215C9.34375 10.7246 9.14062 10.877 8.9375 10.877C8.73437 10.877 8.53125 10.7246 8.53125 10.4707C8.53125 10.2676 8.73437 10.0645 8.9375 10.0645ZM12.1875 10.0645C12.4414 10.0645 12.5937 10.2676 12.5937 10.4707C12.5937 10.7246 12.4414 10.877 12.1875 10.877C11.9844 10.877 11.7812 10.7246 11.7812 10.5215L11.9844 10.1152L12.1875 10.0645Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M10.1562 8.74414H10.9688V10.3691H10.1562V8.74414Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M10.5625 11.9941H13V14.4316H10.5625V11.9941Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M12.5938 11.1816L12.1875 11.5879H8.9375L8.53125 11.1816C8.53125 10.5215 9.44531 9.96289 10.5625 9.96289C11.6797 9.96289 12.5938 10.5215 12.5938 11.1816ZM8.125 11.9941H10.5625V14.4316H8.125V11.9941Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M12.2891 12.9082C12.2891 12.6277 12.0617 12.4004 11.7812 12.4004C11.5008 12.4004 11.2734 12.6277 11.2734 12.9082V13.5176C11.2734 13.798 11.5008 14.0254 11.7812 14.0254C12.0617 14.0254 12.2891 13.798 12.2891 13.5176V12.9082Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M8.53125 12.4004V12.8066H8.9375V13.6191H8.53125V14.0254H10.1562V13.6191H9.75V12.8066H10.1562V12.4004H8.53125ZM8.9375 11.5879H12.1875V11.9941H8.9375V11.5879Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M9.44531 11.1816C9.61359 11.1816 9.75 11.0452 9.75 10.877C9.75 10.7087 9.61359 10.5723 9.44531 10.5723C9.27704 10.5723 9.14062 10.7087 9.14062 10.877C9.14062 11.0452 9.27704 11.1816 9.44531 11.1816Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M10.5625 11.1816C10.7308 11.1816 10.8672 11.0452 10.8672 10.877C10.8672 10.7087 10.7308 10.5723 10.5625 10.5723C10.3942 10.5723 10.2578 10.7087 10.2578 10.877C10.2578 11.0452 10.3942 11.1816 10.5625 11.1816Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M11.6797 11.1816C11.848 11.1816 11.9844 11.0452 11.9844 10.877C11.9844 10.7087 11.848 10.5723 11.6797 10.5723C11.5114 10.5723 11.375 10.7087 11.375 10.877C11.375 11.0452 11.5114 11.1816 11.6797 11.1816Z",
    fill: "#FFDA44"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M8.58203 14.4316V16.6152C8.73373 16.7205 8.90737 16.79 9.08984 16.8184V14.4316H8.58203ZM9.59766 14.4316V16.8184C9.78013 16.79 9.95377 16.7205 10.1055 16.6152V14.4316H9.59766Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M10.5625 15.2441C11.0112 15.2441 11.375 14.8804 11.375 14.4316C11.375 13.9829 11.0112 13.6191 10.5625 13.6191C10.1138 13.6191 9.75 13.9829 9.75 14.4316C9.75 14.8804 10.1138 15.2441 10.5625 15.2441Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M14.625 16.8691H13.8125C13.5881 16.8691 13.4062 17.051 13.4062 17.2754C13.4062 17.4998 13.5881 17.6816 13.8125 17.6816H14.625C14.8494 17.6816 15.0312 17.4998 15.0312 17.2754C15.0312 17.051 14.8494 16.8691 14.625 16.8691Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M7.3125 16.8691H6.5C6.27563 16.8691 6.09375 17.051 6.09375 17.2754C6.09375 17.4998 6.27563 17.6816 6.5 17.6816H7.3125C7.53687 17.6816 7.71875 17.4998 7.71875 17.2754C7.71875 17.051 7.53687 16.8691 7.3125 16.8691Z",
    fill: "#338AF3"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4765_18661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0 0.619141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpain);
export default __webpack_public_path__ + "static/media/spain.5e4f6e310db5b794cfd636403d78f0ee.svg";
export { ForwardRef as ReactComponent };